export default __webpack_public_path__ + "static/banner-standards-1-a4541e7dad3072fab51b2982444db711.jpg";